import React from "react";

const Notification_Icons = {
  User_Module: "account_circle",
  Case: "work",
  "User Locked": "account_circle",
  "New User Registration": "account_circle",
  "Expired Password": "account_circle",
  "Upcoming Password Expiry": "account_circle",
  "In-Active User": "account_circle",
  "Invalid Password": "account_circle",
  "Invalid MFA": "account_circle",
  "Record Sharing": "docs",
  "Appointment Scheduled": "event_available",
  "Appointment Reschedule": "event_available",
  "Appointment Cancelled": "event_available",
  "Appointment Reminder": "event_available",
};

export const Notification_Type = {
  User_Locked: "User Locked",
  New_User_Registration: "New User Registration",
  Expired_Password: "Expired Password",
  Upcoming_Password_Expiry: "Upcoming Password Expiry",
  In_Active_User: "In-Active User",
  Invalid_Password: "Invalid Password",
  Invalid_MFA: "Invalid MFA",
  Record_Sharing: "Record Sharing",
  Appointment_Scheduling: "Appointment Scheduled",
  Appointment_ReScheduling: "Appointment Reschedule",
  Appointment_Cancellation: "Appointment Cancelled",
  Appointment_Reminder: "Appointment Reminder",
};

export default Notification_Icons;
